
import { color } from './Palette'

export default color